import { capturePostHogEvent } from './posthogClient';

export function captureNhStyleFingerprintsView() {
  try {
    capturePostHogEvent('engage-view-nh-style-fingerprints');
  } catch {
    // Analytics must not break the NH style fingerprints page.
  }
}
